import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@fluentui/react';
export const defaultTitle = '404 ~ Not found!';
export const defaultText = (_jsx(Text, { children: "The page you were looking for was either not found or not available!" }));
